export default {
  showResidenceFloorPlansIfAvailable: false
};
